function getMiles(meters) {
  return Math.round(meters * 0.000621371192)
}
function getMPH(mps) {
  return Math.round(mps * 2.24)
}

function getFeet(meters) {
  return Math.round(meters / 0.3048)
}

function pad(num) {
  return ('0' + num).slice(-2)
}

function getHHMMSS(secs) {
  let minutes = Math.floor(secs / 60)
  secs = secs % 60
  let hours = Math.floor(minutes / 60)
  minutes = minutes % 60
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`
  // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
}

function truncate(string, length) {
  if (string === null) return
  return (string.length <= length) ? string : string.substring(0, length) + '…'
}

export { getMiles, getMPH, getFeet, getHHMMSS, truncate }
